<template>
  <div>
    <div class="card mb-2">
      <div class="card-header px-2 py-2 d-flex justify-content-between align-items-center">
        <h5 class="d-flex justify-content-between align-items-center font-weight-bold text-muted m-0">
          <button
            class="btn btn-link text-muted font-weight-bold p-0 header-btn"
            @click="ui.show = !ui.show"
          >
            Duplicate Properties
          </button>
        </h5>
        <button
          class="btn btn-link p-0 header-btn"
          :disabled="disabled || ui.loading"
        >
          Deselect All
        </button>
      </div>
      <div
        v-show="ui.show"
        class="card-body px-2 py-2"
      >
        <template v-if="ui.loading">
          <div class="loader" />
        </template>
        <template v-else>
          <div class="form-row">
            <template v-for="(property, index) in $props.properties">
              <div
                class="col-6 mb-2"
                :key="index"
              >
                <div class="card">
                  <div class="card-header bg-primary text-white p-2 d-flex justify-content-between">
                    <p class="m-0">
                      {{ property.Id }} <small class="text-white">{{ property.Login }}</small>
                    </p>
                    <div class="form-group form-check m-0">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :disabled="disabled"
                      >
                      <label class="form-check-label text-white">Duplicate</label>
                    </div>
                  </div>
                  <div class="card-body p-2">
                    <div class="form-row">
                      <div class="col-6">
                        <p class="m-0">
                          Offer: {{ listingTypes.find(type => type.Id === property.OfferType.Id).Labels['en'] }}
                        </p>
                        <p class="m-0">
                          Price: {{ Intl.NumberFormat().format(property.PriceInEuro) }}€
                        </p>
                        <p class="m-0">
                          Bedrooms: {{ property.Bedrooms }}
                        </p>
                      </div>
                      <div class="col-6">
                        <p class="m-0">
                          Type: {{ propertyTypes.find(type => type.Group === property.Type.GroupId && type.Id === property.Type.Id ).Labels['en'] }}
                        </p>
                        <p class="m-0">
                          Bathrooms: {{ property.Bathrooms }}
                        </p>
                      </div>
                    </div>
                    <div class="form-row">
                      <div
                        v-for="img in property.Photos"
                        class="col-6"
                        :key="img.Number"
                      >
                        <img
                          :src="cdnUrlWithSize(img.CdnUrl, 's640x480')"
                          loading="lazy"
                          class="img-fluid mb-1"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import http from '../../../http';

export default {
    data: () => ( {
        ui: {
            show: true,
            loading: false
        }
    } ),
    computed: {
        listingTypes() {
            return this.$store.getters.listingTypes;
        },
        propertyTypes() {
            return this.$store.getters.propertyTypes;
        },
        propertyID() {
            return this.$props.propertyId !== null ? parseInt( this.$props.propertyId ) : null;
        }
    },
    methods: {
        cdnUrlWithSize( url, size ) {
            const tokens = url.split( '/' );
            const k = tokens[ tokens.length - 1 ];
            const upd = tokens.splice( 0, tokens.length - 1 );
            upd.push( size, k );
            return upd.join( '/' );
        },
        reset() {
            return;
        }
    },
    async created() {
        this.ui.loading = true;

        const response = await http.get( `/property/${this.propertyID}/duplicates` );

        // this.ui.loading = false;

        if ( response.status !== 200 ) {
            return;
        }

        const duplicateProperties = await response.json();
    },
    props: {
        disabled: {
            required: true,
            type: Boolean,
            default: () => false
        },
        propertyId: {
            required: true,
            type: Number,
            default: () => null
        }
    }
};
</script>
<style>
  .loader {
      min-height: 80px;
      width: 100%;
      background: rgba(0, 0, 0, 0.5) url(/src/assets/imgs/loading.gif) center center/45px 45px no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/property-qc/handlers/DuplicatePropertyHandler.vue